var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8195 33.4684C26.1087 33.4684 33.639 25.9763 33.639 16.7342C33.639 7.49216 26.1087 0 16.8195 0C7.53035 0 0 7.49216 0 16.7342C0 25.9763 7.53035 33.4684 16.8195 33.4684Z",
    fill: "#FF7E86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97216 15.0923C11.0608 15.0923 11.9434 14.1754 11.9434 13.0444C11.9434 11.9133 11.0608 10.9964 9.97216 10.9964C8.88351 10.9964 8.00098 11.9133 8.00098 13.0444C8.00098 14.1754 8.88351 15.0923 9.97216 15.0923Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5493 15.0486C24.638 15.0486 25.5205 14.1316 25.5205 13.0006C25.5205 11.8695 24.638 10.9526 23.5493 10.9526C22.4607 10.9526 21.5781 11.8695 21.5781 13.0006C21.5781 14.1316 22.4607 15.0486 23.5493 15.0486Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9028 25.0113C20.7547 25.0113 20.6051 24.966 20.4762 24.872C18.4594 23.3957 15.1781 23.3965 13.1613 24.872C12.8412 25.1069 12.3898 25.0384 12.1545 24.7191C11.9184 24.4006 11.9872 23.9515 12.3081 23.7174C13.5222 22.8288 15.1237 22.3399 16.8196 22.3399C18.5154 22.3399 20.1169 22.8288 21.331 23.7174C21.6511 23.9523 21.7199 24.4006 21.4846 24.7191C21.3438 24.9102 21.1253 25.0113 20.9036 25.0113H20.9028Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeak);
export default __webpack_public_path__ + "static/media/weak.51e405a4b7386d74f19a35f6db0179fa.svg";
export { ForwardRef as ReactComponent };